const btnFinishBuy = document.getElementsByClassName('addDiscount');
const countItems = document.getElementById('orderSize');

async function handleDiscount (){
    let itemsOrder = parseInt(countItems.value);
    let payloadItems= {   
           id:32446702026848,quantity:1
    } ;

        if(itemsOrder > 0){
            alert('este desconto não está disponivel para você.')
            return
        }

       try{
         await fetch('/cart/add.js',{
            headers: {
             
              'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(payloadItems)
                 
              
        });
          
          window.location.href="https://pagamento.pantys.com.br"
       }catch(e){
        console.log(e);
        return
       }
    
};


  

 